import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { getStaffGlobalStatColumnCatalogQueryOptions } from '~/hooks/queries/useStaffGlobalStatColumnCatalogQuery';
import { getStaffStatColumnMetadataQueryOptions } from '~/hooks/queries/useStaffStatColumnMetadataQuery';
import { staffAdminPermsLoader } from './staffAdminPermsLoader';

/** Staff ops admin gate, then kick off column tooltips queries without blocking navigation. */
export function prefetchColumnTooltipsLoader(queryClient: QueryClient) {
  const ensureStaffAdmin = staffAdminPermsLoader(queryClient);

  return async (args: LoaderFunctionArgs) => {
    await ensureStaffAdmin(args);
    queryClient.prefetchQuery(getStaffGlobalStatColumnCatalogQueryOptions(undefined));
    queryClient.prefetchQuery(getStaffStatColumnMetadataQueryOptions());
    return null;
  };
}
